(() => {
  const swatchSelector = '[data-complementary-swatch]';

  /**
   * Creates or retrieves the temporary preview layer for a product card.
   */
  function getPreview(card) {
    let preview = card.querySelector('.complementary-product-preview');

    if (preview) return preview;

    const imageWrap = card.querySelector('.image-label-wrap');
    if (!imageWrap) return null;

    preview = document.createElement('div');
    preview.className = 'complementary-product-preview';
    preview.setAttribute('aria-hidden', 'true');

    const image = document.createElement('img');
    image.className = 'complementary-product-preview__image';
    image.alt = '';
    image.loading = 'eager';

    preview.appendChild(image);
    imageWrap.appendChild(preview);

    return preview;
  }

  /**
   * Displays the image belonging to a swatch.
   */
  function previewSwatch(swatch) {
    const card = swatch.closest('product-block');
    if (!card) return;

    const preview = getPreview(card);
    if (!preview) return;

    if (swatch.dataset.complementaryOriginal === 'true') {
      preview.classList.remove('complementary-product-preview--visible');
      return;
    }

    const imageUrl = swatch.dataset.complementaryImage;
    if (!imageUrl) return;

    const image = preview.querySelector('img');

    if (image.src !== imageUrl) {
      image.src = imageUrl;
    }

    preview.classList.add('complementary-product-preview--visible');
  }

  /**
   * Restores the image selected by click.
   */
  function restoreSelectedSwatch(card) {
    const selected = card.querySelector(
      `${swatchSelector}[aria-pressed="true"]`
    );

    if (selected) {
      previewSwatch(selected);
    }
  }

  /**
   * Handles mouse and pointer hover through event delegation.
   * Delegation also supports cards reloaded through AJAX filters.
   */
  document.addEventListener('pointerover', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    previewSwatch(swatch);
  });

  document.addEventListener('pointerout', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    if (
      event.relatedTarget &&
      swatch.contains(event.relatedTarget)
    ) {
      return;
    }

    const card = swatch.closest('product-block');
    if (card) restoreSelectedSwatch(card);
  });

  /**
   * Makes keyboard focus behave like hover.
   */
  document.addEventListener('focusin', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (swatch) previewSwatch(swatch);
  });

  document.addEventListener('focusout', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    const card = swatch.closest('product-block');
    if (card) restoreSelectedSwatch(card);
  });

  /**
   * Saves the clicked swatch as the persistent card image.
   */
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest(swatchSelector);
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    const card = swatch.closest('product-block');
    if (!card) return;

    card.querySelectorAll(swatchSelector).forEach((item) => {
      const isSelected = item === swatch;

      item.setAttribute(
        'aria-pressed',
        isSelected ? 'true' : 'false'
      );

      item.classList.toggle(
        'complementary-product-swatch--active',
        isSelected
      );
    });

    previewSwatch(swatch);
  });
})();